import { NgModule } from "@angular/core";
import { HorizontalLayout1Module } from "app/layout/horizontal/layout-1/layout-1.module";
import { DialogModule } from "./components/dialog/dialog.module";
import { TableModule } from "./components/table/table.module";
import { ImageFieldComponent } from "./components/image-field/image-field.component";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { CommonModule } from "@angular/common";
import { ImageFieldDefaultComponent } from "./components/image-field-default/image-field-default.component";
import { AvatarModule } from "ngx-avatar";
import { ImageFieldAvatarComponent } from "./components/image-field-avatar/image-field-avatar.component";
import { SquareImageUploadComponent } from "./components/square-image-upload/square-image-upload.component";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
    imports: [
        CommonModule,

        HorizontalLayout1Module,

        DialogModule,

        TableModule,

        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        AvatarModule,
    ],
    exports: [
        MatTableModule,
        MatIconModule,
        MatButtonModule,
        HorizontalLayout1Module,
        DialogModule,
        TableModule,
        ImageFieldComponent,
        ImageFieldAvatarComponent,
        ImageFieldDefaultComponent,
        SquareImageUploadComponent,
    ],
    declarations: [
        ImageFieldAvatarComponent,
        ImageFieldComponent,
        ImageFieldDefaultComponent,
        SquareImageUploadComponent,
    ],
})
export class LayoutModule {}
